import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDiamond"><Path d="M7.5 3.5L1 10L12 21L23 10L16.5 3.5H7.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7 8L5 10L7 12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDiamond;
